<template>
  <v-breadcrumbs :items="items" class="mb-3 mt-0">
    <template v-slot:prepend>
      <v-icon size="small" icon="mdi-home"></v-icon>
    </template>
  </v-breadcrumbs>
</template>
<script>
export default {
  data: () => ({
    items: [],
  }),
  mounted() {
    this.findPath();
  },
  watch: {
    '$route'(to, from) {
      this.findPath()
    }
  },
  methods: {
    findPath() {
      const segments = this.$route.path
        .split("/")
        .filter((segment) => segment !== "");

   
      const breadcrumbs = [{
        title: "HOME",
        disabled: false,
        href: "/",
      }];
      segments.reduce((prev, curr) => {
        const title = curr.toUpperCase();
        const disabled = false;
        const href = prev + "/" + curr;
        breadcrumbs.push({ title, disabled, href });
        return href;
      }, "");

      this.items = breadcrumbs
    },
  },
};
</script>
